/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { pathToArray as t, getProperties as n, isPropertyDeclared as r } from "./utils.js";

function e(t, e) {
  var i = "?" === t[t.length - 1] ? t.slice(0, -1) : t;

  if (null != e.getItemAt || Array.isArray(e)) {
    var _t = parseInt(i, 10);

    if (!isNaN(_t)) return Array.isArray(e) ? e[_t] : e.getItemAt(_t);
  }

  var u = n(e);
  return r(u, i) ? u.get(i) : e[i];
}

function i(t, n, r) {
  if (null == t) return t;
  var u = e(n[r], t);
  return !u && r < n.length - 1 ? void 0 : r === n.length - 1 ? u : i(u, n, r + 1);
}

function u(n, r) {
  var u = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return "string" == typeof r && -1 === r.indexOf(".") ? e(r, n) : i(n, t(r), u);
}

function o(t, n) {
  return u(t, n);
}

function s(t, n) {
  return void 0 !== u(n, t);
}

export { o as default, s as exists, o as get, u as valueOf };